import { useEffect, useRef } from 'react'
import { collection, query, where, onSnapshot } from 'firebase/firestore'
import { db } from '../firebase'

export const useNotifications = (showToast) => {
  const notifiedReviews = useRef(new Set())
  const notifiedContacts = useRef(new Set())
  const notifiedApplications = useRef(new Set())

  useEffect(() => {
    // Listen for new pending reviews
    const reviewsRef = collection(db, 'reviews')
    const reviewsQuery = query(reviewsRef, where('status', '==', 'pending'))

    const unsubscribeReviews = onSnapshot(reviewsQuery, (snapshot) => {
      snapshot.docChanges().forEach(change => {
        if (change.type === 'added') {
          const review = { id: change.doc.id, ...change.doc.data() }
          
          if (!notifiedReviews.current.has(review.id)) {
            showToast(`⭐ Review e re nga ${review.name}! Shiko dashboard për ta aprovuar.`, 'info')
            notifiedReviews.current.add(review.id)
            
            // Play notification sound
            const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBzKM0fPTgjMGHm7A7+OZURE')
            audio.volume = 0.3
            audio.play().catch(() => {})
          }
        }
      })
    })

    // Listen for new contact submissions
    const contactsRef = collection(db, 'contactSubmissions')
    const contactsQuery = query(contactsRef, where('read', '==', false))

    const unsubscribeContacts = onSnapshot(contactsQuery, (snapshot) => {
      snapshot.docChanges().forEach(change => {
        if (change.type === 'added') {
          const contact = { id: change.doc.id, ...change.doc.data() }
          
          if (!notifiedContacts.current.has(contact.id)) {
            showToast(`📧 Mesazh i ri nga ${contact.name}!`, 'info')
            notifiedContacts.current.add(contact.id)
          }
        }
      })
    })

    // Listen for new project applications
    const appsRef = collection(db, 'projectApplications')
    const appsQuery = query(appsRef, where('read', '==', false))

    const unsubscribeApps = onSnapshot(appsQuery, (snapshot) => {
      snapshot.docChanges().forEach(change => {
        if (change.type === 'added') {
          const app = { id: change.doc.id, ...change.doc.data() }
          
          if (!notifiedApplications.current.has(app.id)) {
            showToast(`📝 Aplikacion i ri për projekt nga ${app.name}!`, 'info')
            notifiedApplications.current.add(app.id)
          }
        }
      })
    })

    return () => {
      unsubscribeReviews()
      unsubscribeContacts()
      unsubscribeApps()
    }
  }, [showToast])
}
